module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/page/page.component.less
// module id = ./src/app/component/shared/page/page.component.less
// module chunks = tableDemo.module